/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class OrganizationsActionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Migrate the organization to MDS.
     * Has optional sync query parameter to run the migration synchronously.
     * Sync should only be used for debugging using small organizations.
     * @returns any Accepted
     * @throws ApiError
     */
    public migrateOrganizationToMds({
        organization
    }: {
        /**
         * Organization ID
         */
        organization: number
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organizations/{organization}/dispatch/mds',
            path: {
                organization: organization
            },
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Organization not found.`,
                409: `Migration already in progress.`
            }
        })
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public syncOrganizationsTithelyBilling({
        organization,
        requestBody
    }: {
        /**
         * Organization ID
         */
        organization: number
        requestBody?: {
            ignore_coupon?: boolean
        }
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organizations/{organization}/dispatch/sync-billing',
            path: {
                organization: organization
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Organization not found.`
            }
        })
    }

    /**
     * Sync Org with MDS.
     * Has optional audit query parameter to only analyze and log.
     * @returns any Accepted
     * @throws ApiError
     */
    public syncMds({
        organization,
        auditOnly
    }: {
        /**
         * Organization ID
         */
        organization: number
        /**
         * Run the migration With Audit Only
         */
        auditOnly?: boolean
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organizations/{organization}/dispatch/sync-mds',
            path: {
                organization: organization
            },
            query: {
                audit_only: auditOnly
            },
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Organization not found.`,
                409: `Migration already in progress.`
            }
        })
    }
}
